export default "__VITE_ASSET__BRLBerHl__"